import { environment } from '@environments/environment';
import { RegionAvailable } from '@shared/services/language/registry';

export const envConfiguredGtmId = (region: RegionAvailable) => environment.domains[region].gtmId ?? '';
